import { render, staticRenderFns } from "./Camiones.vue?vue&type=template&id=90ba2b0a&"
import script from "./Camiones.vue?vue&type=script&lang=ts&"
export * from "./Camiones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports